import React from "react";
import { LoginScreenWithAuthDataWithAuthData } from "~/features/book-appointment/StandaloneBookingLoginScreen";

const Component = () => {
  return <LoginScreenWithAuthDataWithAuthData />;
};

export default Component;
